var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 3.58301C27.4492 3.58318 28.083 4.21771 28.083 5C28.083 5.78229 27.4492 6.41682 26.667 6.41699H8.33301C7.82479 6.41708 7.33788 6.61915 6.97852 6.97852C6.61915 7.33788 6.41708 7.82479 6.41699 8.33301V31.667C6.41708 32.1752 6.61915 32.6621 6.97852 33.0215C7.33788 33.3809 7.82479 33.5829 8.33301 33.583H31.667C32.1752 33.5829 32.6621 33.3809 33.0215 33.0215C33.3809 32.6621 33.5829 32.1752 33.583 31.667V20C33.583 19.2176 34.2176 18.583 35 18.583C35.7824 18.583 36.417 19.2176 36.417 20V31.667C36.4169 32.9267 35.9161 34.1347 35.0254 35.0254C34.1347 35.9161 32.9267 36.4169 31.667 36.417H8.33301C7.07335 36.4169 5.86533 35.9161 4.97461 35.0254C4.08389 34.1347 3.58309 32.9267 3.58301 31.667V8.33301C3.58309 7.07335 4.08389 5.86533 4.97461 4.97461C5.86533 4.08389 7.07335 3.58309 8.33301 3.58301H26.667ZM35.665 6.49805C36.2182 5.94508 37.1148 5.94518 37.668 6.49805C38.2212 7.05129 38.2212 7.94871 37.668 8.50195L21.002 25.168C20.4487 25.7212 19.5513 25.7212 18.998 25.168L13.998 20.168C13.4452 19.6148 13.4451 18.7182 13.998 18.165C14.5513 17.6118 15.4487 17.6118 16.002 18.165L20 22.1631L35.665 6.49805Z",
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquareIcon);
export default __webpack_public_path__ + "static/media/checkSquareIcon.56b3395b1344d5a4bc0e7d52ceffaacf.svg";
export { ForwardRef as ReactComponent };